import { STYLE_MODAL } from 'redhotpie-shared-lib/constants/constants';
import { IModalComponentProps, ConfirmationModalProps } from './types/modalTypes';
import { getStore } from 'redhotpie-shared-lib/store/myStore';
import { phoneDetect } from './utils';
import { onShowConfirmModal } from 'redhotpie-shared-lib/actions/commonStateAction';
/*
 *
 * */
export function handleShowConfirmModal({
  headerText = '',
  messageConfirm,
  messageConfirmExternal = '',
  messageConfirmExternal2 = '',
  okText = '',
  okAction = () => {},
  cancelText = '',
  cancelAction = () => {},
  className = STYLE_MODAL.BLOCK_MODAL,
  customClassButton = '',
  customClassCancle = '',
  customClassOk = '',
  disableCancel = false,
  disableClickOverlay = false,
  noClearCancelAction = false,
  keepModalWhenClickCancel = false,
  isMoreEndGroupChat = false,
  disableEscClose = false,
  disableBackBrowserCloseModal = false,
  wrapperPosition,
  extraFooter = null,
  callbackRunAnimation = undefined,
  noClearCallbackRunAnimation = false,
  isBottomModal = false,
  isOptionModal = false,
  customZIndex = '',
  customOverlayClassName = '',
  isOverlayBlack = false,
  isOverlayGray = false,
}: ConfirmationModalProps) {
  const store = getStore();
  const isMobile = phoneDetect();

  store.dispatch(
    onShowConfirmModal({
      headerText,
      messageConfirm,
      messageConfirmExternal,
      messageConfirmExternal2,
      onOkAction: (callbackCancel: any, callbackRunAnimation: any, params: any) => {
        if (typeof okAction === 'function') {
          okAction(params);
        }
      },
      okText,
      classNames: `${className} ${!isMobile ? 'notification-modal-desktop' : ''}`,
      cancelText: cancelText,
      onCancelAction: () => {
        if (typeof cancelAction === 'function') {
          cancelAction();
        }
      },
      disableCancel,
      disableClickOverlay,
      customClassOk,
      noClearCancelAction,
      keepModalWhenClickCancel,
      customClassCancle,
      isMoreEndGroupChat,
      wrapperPosition,
      disableEscClose,
      disableBackBrowserCloseModal,
      customClassButton,
      extraFooter,
      callbackRunAnimation,
      noClearCallbackRunAnimation,
      isBottomModal,
      isOptionModal,
      customZIndex,
      customOverlayClassName,
      isOverlayBlack,
      isOverlayGray,
    })
  );
}
